import type {
  AnchorHTMLAttributes,
  ReactNode
} from 'react';

import
  Link
from 'next/link';

// Padding/gap deliberately excluded, matching PRIMARY_BUTTON_CLASSES's
// convention (see brand.ts) - callers supply their own via className.
export const SECONDARY_BUTTON_CLASSES = 'cursor-pointer text-center text-sm font-semibold rounded-full border border-[rgba(1,158,250,0.5)] text-[rgba(1,158,250,1)] dark:border-[rgba(1,158,250,0.6)] dark:text-[rgba(1,158,250,1)] transition-all duration-150 hover:bg-[rgba(1,158,250,0.08)] dark:hover:bg-[rgba(1,158,250,0.12)] hover:scale-[1.02] focus:outline-none focus:border-[rgba(1,158,250,1)] active:scale-[0.98]';

interface SecondaryButtonProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string
  children: ReactNode
  // Plain <a> instead of next/link's <Link> - for external hrefs (wa.me,
  // mailto:), matching PrimaryButton's identical reasoning.
  external?: boolean
  // Full-width block layout - default is an inline pill, matching
  // PrimaryButton's convention. Existing full-width callers must pass this.
  block?: boolean
}

// Outline counterpart to FormSubmitButton's solid gradient treatment - for
// CTAs that shouldn't compete visually with a page's one highlighted/primary
// action (e.g. non-"Recommended" pricing cards).
export default function SecondaryButton({
  href, children, className, external, block, ...props
}: SecondaryButtonProps) {

  const layout = block ? 'block' : 'inline-flex items-center justify-center';

  const mergedClassName = className
    ? `${ layout } ${ SECONDARY_BUTTON_CLASSES } ${ className }`
    : `${ layout } ${ SECONDARY_BUTTON_CLASSES }`;

  if (external) {

    return (
      <a
        href={href}
        className={mergedClassName}
        {...props}
      >
        {children}
      </a>
    );
  }

  return (
    <Link
      href={href}
      className={mergedClassName}
      {...props}
    >
      {children}
    </Link>
  );
}
